import * as t from "react";
import { u as c } from "./useEnhancedEffect-CJGo-L3B.mjs";
function s(e) {
  const r = t.useRef(e);
  return c(() => {
    r.current = e;
  }), t.useRef((...u) => (
    // @ts-expect-error hide `this`
    (0, r.current)(...u)
  )).current;
}
export {
  s as u
};
//# sourceMappingURL=useEventCallback-B4gn-DZo.mjs.map
